import * as types from './constants';

// Activate Code
export const activateCodeRequest = data => (
  { type: types.ACTIVATE_CODE_REQUEST, payload: data }
);

export const activateCodeDone = data => (
  { type: types.ACTIVATE_CODE_DONE, payload: data }
);

export const activateCodeFailed = errors => (
  { type: types.ACTIVATE_CODE_FAILED, payload: errors }
);